import { AccountFeatures, AppContext, Features } from '@lightspeed-invoicing/core-client/frontend'
import $ from "jquery"
import moment from "moment"
import 'popper.js'
import React, { Component } from 'react'
import { defineMessages, FormattedDate, FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import BottomPriceToggle from "../bottom-line/toggle.component"
import ActionButton from "../common/button/actionbutton.component.jsx"
import ConfirmButton from "../common/button/confirmbutton.component.jsx"
import CustomFieldLabel from "../common/custom-field/label.component.jsx"
import CustomFieldValue from "../common/custom-field/value.component.jsx"
import SendEmailModal from '../common/email/sendemail.component.jsx'
import EventBus from "../common/EventBus.js"
import GlobalHelper from "../common/GlobalHelper.jsx"
import Icon from "../common/icon/icon.component.jsx"
import InlineEditDate from '../common/inline-edit/date.component.jsx'
import InlineEditLocation from "../common/inline-edit/location.component.jsx"
import InlineEditText from "../common/inline-edit/text.component.jsx"
import InlineEditUser from "../common/inline-edit/user.component.jsx"
import SideBar from "../common/layout/sidebar.component.jsx"
import AddPricingRow from "../common/pricing/addItem.component.jsx"
import PricingTableTotals from "../common/pricing/totals.component.jsx"
import ProposalPreviewModal from '../common/proposal/previewmodal.component.jsx'
import QuoteCurrency from "../common/quote/currency.component.jsx"
import QuoteIdentifier from "../common/quote/identifier.component.jsx"
import SendSmsModal from "../common/sms/SendSmsModal"
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import Integrations from "../integration/Integrations.jsx"
import PricingTableContent from '../pricing/PricingTableContentComponent.jsx'
import ProjectCustomerEditForm from "../quote/project/customerselectform.component.jsx"
import ProjectDetailsEditForm from '../quote/project/details.component.jsx'
import { isError } from '../state/helpers/Error'
import { INTEGRATION_KEY } from "../state/integration/Constants"
import { INVOICES, REFUND_TYPE } from "../state/invoice/Constants"
import { BILLING_TYPE } from '../state/invoice/InvoiceBillingType'
import RefundPayments from '../state/payment/refund/RefundPayments'
import RefundService from '../state/payment/refund/RefundService'
import { fetchPriceLevels } from '../state/price-level/PriceLevelActions'
import PriceListService from "../state/price-list/PriceListService"
import {
    setPricingTable,
    setPricingTableGroups,
    setPricingTableInitialState
} from '../state/pricing/actions'
import { EMAIL_TEMPLATE, TYPE_SMS_INVOICE } from "../state/template/TemplateType"
import InvoiceAnalytics from "./analytics.component.jsx"
import PaymentRefundModal from './components/PaymentRefundModal/PaymentRefundModal'
import RefundConfirmationModal from './components/RefundConfirmationModal/RefundConfirmationModal'
import SendAsModal from "./components/SendAsModal"
import CreditLimitProtectionButton from './CreditLimitProtectionButton'
import InvoiceDueDate from "./duedate.component.jsx"
import InvoiceHelper from "./invoicehelper.jsx"
import InvoicePaymentTerm from './paymentterm.component.jsx'
import ReceivePaymentModal from "./receivepaymentmodal.component.jsx"
import InvoiceRecurring from "./recurring.component.jsx"
import RecurringInvoiceInterval from "./recurring/interval.component.jsx"
import RecurringInvoiceOptions from "./recurring/options.component.jsx"
import RecurringInvoiceSchedule from "./recurring/schedule.component.jsx"
const queryString = require('query-string')
const uuidv4 = require("uuid/v4")

const messages = defineMessages({
    "group_default_name": {
        id: 'invoice.edit.group.group_default_name',
        defaultMessage: 'Unnamed group',
    }
})

const REFUND_MODAL_ID = "payment-refund-modal-" + uuidv4()

class InvoiceEdit extends Component {

    constructor(props, context) {
        super(props, context)

        let firstRecurringInvoice = null
        let showReceivePaymentModal = false
        if (this.props.location && this.props.location.state) {
            if (this.props.location.state.firstRecurringInvoice) {
                firstRecurringInvoice = this.props.location.state.firstRecurringInvoice
            }
            if (this.props.location.state.showReceivePaymentModal) {
                showReceivePaymentModal = this.props.location.state.showReceivePaymentModal
            }
        }

        let todayDate = moment().toDate()
        todayDate.setHours(0, 0, 0, 0)
        todayDate = moment(todayDate.toISOString()).format('YYYY-MM-DD')

        this.state = {
            status: '',
            createdAt: null,
            contactId: '',
            redirect: '',
            sellerName: '',
            sellerId: '',
            totalTax: '0',
            totalAmount: '0',
            totalAmountWithoutTax: '0',
            totalDiscountAmount: '0',
            depositAmount: '0',
            depositRatio: 0,
            taxCalculations: [],
            quoteReference: null,
            orderReference: null,
            priceListReference: null,
            items: [],
            depositType: "",
            externalOrders: [],
            internalNotes: [],
            groups: [],
            emails: [],
            templates: [],
            customFieldDefinitions: [],
            invoice: null,
            externalExport: null,
            proposal: null,
            projectObject: null,
            currency: '',
            documentLink: '',
            billingType: 'one-time',
            recurringInfo: null,
            identifierId: '',
            sentAt: '',
            addItemModal: '',
            identifier: '',
            poNumber: '',
            exchangeRate: '',
            deletedAt: '',
            hash: '',
            invoiceId: this.props.match.params.invoiceId,
            loading: true,
            editable: true,
            editMode: false,
            exportedToLightspeed: false,
            invoiceEmailTemplate: null,
            contact: null,
            firstRecurringInvoice,
            todayDate,
            emailSubject: '',
            emailContent: '',
            toEmail: '',
            ccEmail: '',
            buttonLabel: '',
            returns: [],
            refundModalVisible: false,
            willShowReceivePaymentModal: false,
            showReceivePaymentModal,
            creditMemoFromQuoteExists: false,
            customerAccount: null,
            previewLoading: false,
            paymentFromDraft: false,
        }
        this.deleteInvoice = this.deleteInvoice.bind(this)
        this.unarchiveInvoice = this.unarchiveInvoice.bind(this)
        this.addGroup = this.addGroup.bind(this)
        this.updateContact = this.updateContact.bind(this)
        this.review = this.review.bind(this)
        this.refreshInvoice = this.refreshInvoice.bind(this)
        this.handleInvoiceRefresh = this.handleInvoiceRefresh.bind(this)
        this.handleEditInvoice = this.handleEditInvoice.bind(this)
        this.closeEditMode = this.closeEditMode.bind(this)
        this.openEditInvoiceItemModal = this.openEditInvoiceItemModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.handleAddInvoiceItemModal = this.handleAddInvoiceItemModal.bind(this)
        this.handleAddProductLink = this.handleAddProductLink.bind(this)
        this.markAsActive = this.markAsActive.bind(this)
        this.markAsInactive = this.markAsInactive.bind(this)
        this.markAsSent = this.markAsSent.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.openSendEmail = this.openSendEmail.bind(this)
        this.sendProposal = this.sendProposal.bind(this)
        this.saveRecurringEmail = this.saveRecurringEmail.bind(this)
        this.configureRecurringEmail = this.configureRecurringEmail.bind(this)
        this.isShopifyReturn = this.isShopifyReturn.bind(this)
        this.loadDefinitions = this.loadDefinitions.bind(this)
        this.openSendSms = this.openSendSms.bind(this)
        this.setGlobalStateInitialValues = this.setGlobalStateInitialValues.bind(this)
        this.createProposalAndOpenSms = this.createProposalAndOpenSms.bind(this)
        this.receivePayment = this.receivePayment.bind(this)
        this.handlePaymentOnDraft = this.handlePaymentOnDraft.bind(this)
        this.printPdf = this.printPdf.bind(this)
        this.handleRefund = this.handleRefund.bind(this)
        this.mapOnAccountRefundResponseToRefundPaymentsResponse = this.mapOnAccountRefundResponseToRefundPaymentsResponse.bind(this)
    }

    componentDidMount() {
        this.props.dispatch(setPricingTableInitialState)
        this.refreshInvoice()
        SideBar.activateMenu('invoice')
        const uri = queryString.parse(this.props.location.search)
        this.setState({
            editMode: uri.em === '1',
        })
        AppContext.getApiClient().get('/custom-field-definitions').then(res => {
            this.setState({
                customFieldDefinitions: res.data,
            })
        })
        AppContext.getApiClient().get('/templates/' + EMAIL_TEMPLATE.TYPE_EMAIL_INVOICE + '/template').then(t => {
            this.setState({
                invoiceEmailTemplate: t,
            })
        })

        if (this.props.location && this.props.location.state && this.props.location.state.contactId) {
            this.updateContact(this.props.location.state.contactId)
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.match && nextProps.match.params) {
            this.refreshInvoice(nextProps.match.params.invoiceId)
        }
    }

    loadDefinitions() {
        AppContext.getApiClient().get('/custom-field-definitions').then(res => {
            let definitionsToApply = res.data.filter(def => def.attributes.availableFrom &&
                (def.attributes.availableFrom.includes(this.state.projectObject.attributes.documentType) || !this.state.projectObject.attributes.documentType))
            this.setState({
                customFieldDefinitions: definitionsToApply,
            })
        })
    }

    refreshInvoice(value) {
        let invoiceId = ''
        if (value && typeof value === "string") {
            invoiceId = value
        }
        if (invoiceId && invoiceId !== this.state.invoiceId) {
            window.scrollTo(0, 0)
        }
        if (!invoiceId) {
            invoiceId = this.state.invoiceId
        }

        AppContext.getApiClient().get('/invoices/' + invoiceId).then(inv => {
            if (this.state.identifier !== inv.attributes.identifier || this.state.status !== inv.attributes.status) {
                const typePath = inv.attributes.billingType === BILLING_TYPE.RETURN ? "returns" : "invoices"
                EventBus.dispatch(EventBus.TopicUrlPathChange, {
                    path: `/${typePath}/${invoiceId}/edit`
                })
            }

            if (inv.attributes.quoteReferenceId) {
                AppContext.getApiClient().get(`/quotes/` + inv.attributes.quoteReferenceId).then(q => {
                    this.setState({
                        quoteReference: q
                    })
                })
            }
            if (inv.attributes.priceListId) {
                PriceListService.get(inv.attributes.priceListId).then(pl =>
                    this.setState({
                        priceListReference: pl.getDto(),
                    })
                )
            }
            else if (inv.attributes.orderReferenceId) {
                AppContext.getApiClient().get(`/orders/` + inv.attributes.orderReferenceId).then(o => {
                    this.setState({
                        orderReference: o
                    }, () => {
                        if (this.state.orderReference.attributes.priceListReferenceId) {
                            AppContext.getApiClient().get(`/price-lists/` + this.state.orderReference.attributes.priceListReferenceId).then(pl => {
                                this.setState({
                                    priceListReference: pl,
                                })
                            })
                        }
                    })
                })
            }
            if (inv.attributes.quoteReferenceId || inv.attributes.orderReferenceId) {
                AppContext.getApiClient().get(`/contacts/${inv.attributes.contactId}/credit-memos`).then(res => {
                    const creditMemo = res.data.find(cm => {
                        return (inv.attributes.quoteReferenceId && cm.attributes.quoteReferenceId === inv.attributes.quoteReferenceId) ||
                            (inv.attributes.orderReferenceId && cm.attributes.orderReferenceId === inv.attributes.orderReferenceId)
                    })
                    if (creditMemo) {
                        this.setState({
                            creditMemoFromQuoteExists: true,
                        })
                    }
                })
            }

            if (inv.attributes.projectId) {
                AppContext.getApiClient().get('/projects/' + inv.attributes.projectId).then(p => {
                    this.setState({
                        projectObject: p,
                        internalNotes: p.attributes?.internalNotes || [],
                    }, () => this.loadDefinitions())
                })
            }
            if (inv.attributes.recurringInvoiceId) {
                AppContext.getApiClient().get('/invoices/' + inv.attributes.recurringInvoiceId).then(q => {
                    this.setState({
                        recurringInvoice: q
                    })
                })
            } else {
                this.setState({
                    recurringInvoice: null
                })
            }
            if (inv.attributes.returnOfInvoiceId) {
                AppContext.getApiClient().get('/invoices/' + inv.attributes.returnOfInvoiceId).then(i => {
                    this.setState({
                        relatedInvoice: i
                    })
                })
            } else {
                this.setState({
                    relatedInvoice: null
                })
            }
            AppContext.getApiClient().get(`/invoices/${invoiceId}/returns`).then(res => {
                this.setState({
                    returns: res.data
                })
            })
            if (!['draft'].includes(inv.attributes.status) && inv.attributes.proposalHash) {
                AppContext.getApiClient().get('/proposals/' + inv.attributes.proposalHash).then(res => {
                    if (!res.error) {
                        this.loadProposal(res)
                    }
                })
            } else {
                AppContext.getApiClient().get('/invoices/' + invoiceId + '/proposals').then(res => {
                    //quick fix for invoices that are linked to multiple proposals but there should only be one
                    if (res.data && res.data.length > 0) {
                        const proposal = res.data.reduce(function (prev, current) {
                            return (prev.attributes.totalTimeSpent > current.attributes.totalTimeSpent) ? prev : current
                        })
                        this.loadProposal(proposal)
                    }
                })
            }
            const recurringInfo = inv.attributes.recurringInfo
            if (recurringInfo) {
                SideBar.activateMenu('subscription')
            }

            AppContext.getApiClient().get('/customer-accounts/' + inv.attributes.contactId).then(res => {
                if (res.error) {
                    return
                }
                this.setState({
                    customerAccount: res
                })
            })

            this.setState({
                loading: false,
                invoice: inv,
                invoiceId: inv.id,
                deletedAt: inv.attributes.deletedAt,
                identifierId: inv.attributes.identifierId,
                identifier: inv.attributes.identifier,
                status: inv.attributes.status,
                dueDate: inv.attributes.dueDate,
                billingType: inv.attributes.billingType,
                recurringInfo: inv.attributes.recurringInfo || null,
                exports: inv.attributes.exports,
                groups: inv.attributes.groups,
                externalOrders: inv.attributes.externalOrders,
                contactId: inv.attributes.contactId,
                contact: inv.attributes.contact,
                totalAmount: inv.attributes.totalAmount,
                totalTax: inv.attributes.totalTax,
                totalAmountWithoutTax: inv.attributes.totalAmountWithoutTax,
                discountTotalAmount: inv.attributes.discountTotalAmount,
                taxCalculations: inv.attributes.taxCalculations,
                currency: inv.attributes.currency,
                exchangeRate: inv.attributes.exchangeRate,
                poNumber: inv.attributes.poNumber,
                items: inv.attributes.items,
                totals: inv.attributes.totals,
                depositAmount: inv.attributes.depositAmount,
                depositRatio: inv.attributes.depositRatio,
                depositType: inv.attributes.depositType,
                createdAt: inv.attributes.createdAt,
                sentAt: inv.attributes.sentAt,
                paymentTerm: inv.attributes.paymentTerm ? inv.attributes.paymentTerm.attributes.name : '',
                paymentTermId: inv.attributes.paymentTermId,
                sellerName: inv.attributes.seller.attributes.firstName + ' ' + inv.attributes.seller.attributes.lastName,
                locationName: inv.attributes.location ? inv.attributes.location.attributes.name : '',
                locationId: inv.attributes.locationId,
                sellerId: inv.attributes.seller.id,
                exportedToLightspeed: inv.attributes.externalLinks.filter(l => l.attributes.integrationKey === INTEGRATION_KEY.LIGHTSPEED_RETAIL).length > 0,
                emailSubject: recurringInfo ? recurringInfo.attributes.emailSubject : '',
                emailContent: recurringInfo ? recurringInfo.attributes.emailContent : '',
                toEmail: recurringInfo ? recurringInfo.attributes.emailAddresses : '',
                ccEmail: recurringInfo ? recurringInfo.attributes.emailCCAddresses : '',
                buttonLabel: recurringInfo ? recurringInfo.attributes.emailButtonLabel : '',
            }, () => {
                this.setGlobalStateInitialValues()
                if (this.state.willShowReceivePaymentModal) {
                    this.setState({
                        showReceivePaymentModal: true,
                    }, () => {
                        this.setState({
                            willShowReceivePaymentModal: false,
                            showReceivePaymentModal: false,
                        })
                    })
                } else if (this.state.showReceivePaymentModal) {
                    this.setState({
                        showReceivePaymentModal: false,
                    })
                }
            })
        })
    }

    setGlobalStateInitialValues() {
        this.props.dispatch(fetchPriceLevels())
        this.props.dispatch(setPricingTable(this.state.invoice))
    }

    loadProposal(proposal) {
        if (proposal && proposal.attributes) {
            this.setState({
                proposal: proposal,
                hash: proposal.attributes.hash,
                pdfUri: proposal.attributes.variables.document.pdfUri,
                publicLink: proposal.attributes.publicLink,
            })
            AppContext.getApiClient().get('/proposals/' + proposal.id + '/emails').then(res => {
                const emails = res.data || []
                this.setState({
                    emails: emails,
                })
            })
        } else {
            this.setState({
                proposal: null
            })
        }
    }

    deleteInvoice(event) {
        event.preventDefault()
        AppContext.getApiClient().delete('/invoices/' + this.state.invoiceId, {}).then(res => {
            this.refreshInvoice()
        })
    }

    unarchiveInvoice(event) {
        event.preventDefault()
        AppContext.getApiClient().put('/invoices/' + this.state.invoiceId + '/unarchive', {}).then(res => {
            this.setState({ editable: true })
            this.refreshInvoice()
        })
    }

    updateContact(contactId) {
        if (contactId) {
            AppContext.getApiClient().patch('/invoices/' + this.state.invoiceId, {
                contactId: contactId
            }).then(res => {
                this.setState({
                    contactId: contactId
                })
                this.refreshInvoice()
            })
        }
    }

    addGroup(event) {
        event.preventDefault()
        let groupId = ''
        return AppContext.getApiClient().post('/invoices/' + this.state.invoiceId + '/groups', {
            name: this.props.intl.formatMessage(messages['group_default_name']),
            rank: this.state.groups.length
        }).then(g => {
            groupId = g.id
            return AppContext.getApiClient().get('/invoices/' + this.state.invoiceId)
        }).then(inv => {
            this.setState({ groups: inv.attributes.groups }, () => {
                this.props.dispatch(setPricingTableGroups(this.state.groups, this.state.invoiceId))
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('#sortable-quote-group-' + groupId)?.offset()?.top - 100
                }, 500)
            })
        })
    }

    openEditInvoiceItemModal(itemId, productId) {
        this.setState({
            modal: <AddPricingRow
                object={this.state.invoice}
                mainObject={'invoices'}
                mainObjectItem={'invoice-items'}
                objectId={this.state.invoiceId}
                objectIdentifier={this.state.identifier}
                onClose={this.handleCloseModal}
                itemId={itemId}
                productId={productId}
                currency={this.state.currency}
                exchangeRate={this.state.exchangeRate}
                onItemAdd={this.handleAddInvoiceItemModal}
                forceBillingMethod={'one-time'}
                isReturn={this.isReturn()}
                location={this.state.invoice.attributes.location}
            />
        })
    }

    handleAddProductLink(e) {
        e.preventDefault()
        this.openEditInvoiceItemModal()
    }

    handleAddInvoiceItemModal(keepOpen) {
        this.refreshInvoice()
        if (keepOpen) {
            return
        }
        this.setState({
            modal: '',
        })
    }

    handleCloseModal() {
        this.refreshInvoice()
        this.setState({
            modal: '',
            loading: false,
            refundModalVisible: false,
        })
        if (this.state.paymentFromDraft) {
            this.setState({
                paymentFromDraft: false
            })
            this.sendProposal("", "", "", "", "", "", "", "", "", false)
        }
    }


    renderItems(items, allowEdit) {
        return <PricingTableContent
            tableId={this.state.invoice.attributes.pricingTableId}
            projectId={this.state.projectObject && this.state.projectObject.id}
            objectId={this.state.invoiceId}
            mainObject={'invoices'}
            invoiceId={this.state.invoiceId}
            onUpdate={() => {
                this.refreshInvoice()
            }}
            currency={this.state.currency}
            allowEdit={allowEdit}
            sortable={true}
            onEditLinkClick={this.openEditInvoiceItemModal}
        />


    }

    createProposal() {
        if (this.state.proposal && this.state.proposal.attributes.variables.quote.id === this.state.invoiceId) {
            return Promise.resolve(this.state.proposal)
        }
        return AppContext.getApiClient().get(`/invoices/${this.state.invoiceId}/proposals`).then((res) => {
            const invoiceProposals = res.data
            if (invoiceProposals.length > 0) {
                return Promise.resolve(invoiceProposals[0])
            } else {
                return AppContext.getApiClient().post('/proposals', {
                    invoiceId: this.state.invoiceId,
                    contactId: this.state.contactId
                })
            }
        })
    }

    review(event) {
        event.preventDefault()
        const uri = this.state.editMode ? '?em=1' : ''
        this.createProposal().then(res => {
            this.setState({
                redirect: <Redirect to={{
                    pathname: '/proposals/' + res.attributes.hash + '/preview',
                    search: uri,
                    state: {
                        creditMemoFromQuoteExists: this.state.creditMemoFromQuoteExists,
                        owingBalance: this.getCustomerOwingBalance(),
                        invoiceBalance: parseFloat(this.state.invoice.attributes.baseCurrencyTotalAmount),
                        creditLimit: parseFloat(this.state.contact.attributes.creditLimit),
                        invoiceCurrency: this.state.invoice.attributes.currency,

                    }
                }}
                />
            })
        })
    }

    handleInvoiceRefresh(value) {
        this.refreshInvoice(value)
    }

    handleEditInvoice(invoiceId) {
        this.refreshInvoice(invoiceId)
        this.setState({
            editMode: true,
        })
        window.scrollTo(0, 0)
    }

    closeEditMode(e) {
        e.preventDefault()
        this.refreshInvoice()
        this.setState({
            editMode: false,
        })
        window.scrollTo(0, 0)
    }

    renderCustomField(col) {
        if (!this.state.projectObject || !this.state.projectObject.attributes) {
            return []
        }
        return this.state.customFieldDefinitions.filter((_, index) => {
            const nbPerCol = Math.ceil(this.state.customFieldDefinitions.length / 2)
            if (col === 0) {
                return index < nbPerCol
            } else {
                return index >= nbPerCol
            }
        }).map(def => {
            const value = this.state.projectObject.attributes.customFieldValues[def.id]
            return <div className={'w-100'} key={def.id}>
                <div className="w-100">
                    <label className="col-form-label custom-form-label">
                        <CustomFieldLabel definitionId={def.id} />
                    </label>
                </div>
                <div className="w-100">
                    <CustomFieldValue
                        definitionId={def.id}
                        value={value}
                        elementId={this.state.projectObject.id}
                        invoiceId={this.state.invoiceId}
                        editable={true} />
                </div>
            </div>
        })
    }

    sendProposal(subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail, skipRefresh) {
        window.scrollTo(0, 0)
        this.createProposal().then(res => {
            AppContext.getApiClient().post('/proposals/' + res.attributes.hash + '/send-by-email', {
                subject: subject,
                toEmail: toEmail,
                ccEmail: ccEmail,
                content: content,
                buttonLabel: buttonLabel,
                attachments: pdfIncluded ?
                    [
                        {
                            name: res.attributes.variables.document.reference.concat(".pdf"),
                            fileLink: res.attributes.variables.document.pdfUri,
                            contentType: "application/pdf",
                        }
                    ] : [],
                fromEmail: fromEmail,
                bccEmail: bccEmail,
            }).then(res => {
                if (res.id) {
                    if (!this.isReturn() && this.state.creditMemoFromQuoteExists) {
                        this.setState({
                            willShowReceivePaymentModal: true,
                        })
                    }
                    if (!skipRefresh) {
                        this.refreshInvoice(this.state.invoiceId)
                    }
                } else {
                    this.setState({ loading: false })
                }
            })
        })
    }

    nextDueDateIsToday() {
        const recurringInfo = this.state.recurringInfo.attributes
        const nextDueDate = moment(recurringInfo.nextDueDate).format('YYYY-MM-DD')
        return (nextDueDate == this.state.todayDate)
    }

    saveRecurringEmail(subject, toEmail, ccEmail, content, buttonLabel, status, templateKey, fromEmail, bccEmail, fromName) {
        window.scrollTo(0, 0)
        this.setState({ loading: true })
        let data = {}
        if (status) {
            data["status"] = status
        }
        const recurringInfo = this.state.recurringInfo && this.state.recurringInfo.attributes ? this.state.recurringInfo.attributes : {}
        data.recurringInfo = {
            emailSubject: subject,
            emailAddresses: toEmail,
            emailCCAddresses: ccEmail,
            emailContent: content,
            emailButtonLabel: buttonLabel,
            emailFromName: fromName,
        }

        this.createProposal().then(proposal => {
            AppContext.getApiClient().patch('/invoices/' + this.state.invoiceId, data).then(res => {
                const recInfo = res.attributes.recurringInfo.attributes
                this.setState({
                    emailSubject: recInfo.emailSubject,
                    toEmail: recInfo.emailAddresses,
                    ccEmail: recInfo.emailCCAddresses,
                    emailContent: recInfo.emailContent,
                    buttonLabel: recInfo.emailButtonLabel,
                    emailFromName: recInfo.emailFromName,
                })
                data["proposalId"] = proposal.id
                if (status === 'active' && this.nextDueDateIsToday() && recurringInfo.createdInvoiceCount === 0) {
                    this.activateAndCreateFirstRecurringInvoice(data)
                } else {
                    if (res.id) {
                        this.refreshInvoice(res.id)
                    } else {
                        this.setState({ loading: false })
                    }
                }
            })
        })
    }

    activateAndCreateFirstRecurringInvoice(data) {
        AppContext.getApiClient().post(`/invoices/${this.state.invoiceId}/activate`, data).then(res => {
            this.setState({
                editMode: false,
                firstRecurringInvoice: res.attributes.recurringInfo.attributes.firstRecurringInvoice,
            })
            if (res.id) {
                this.refreshInvoice(res.id)
            } else {
                this.setState({
                    loading: false,
                })
            }
        })
    }

    markAsInactive(e) {
        e.preventDefault()
        const template = this.state.invoiceEmailTemplate ? this.state.invoiceEmailTemplate.attributes : {}
        this.saveRecurringEmail(
            this.state.emailSubject || template.subject,
            this.state.toEmail || this.getCustomerEmailAddresses(),
            this.state.ccEmail || '',
            this.state.emailContent || template.content,
            this.state.buttonLabel || template.buttonLabel,
            'inactive')
    }

    markAsActive(e) {
        e.preventDefault()
        const template = this.state.invoiceEmailTemplate ? this.state.invoiceEmailTemplate.attributes : {}
        this.saveRecurringEmail(
            this.state.emailSubject || template.subject,
            this.state.toEmail || this.getCustomerEmailAddresses(),
            this.state.ccEmail || '',
            this.state.emailContent || template.content,
            this.state.buttonLabel || template.buttonLabel,
            'active')
    }

    async handleRefund(type, payload) {
        let refundPayments;

        if (type === REFUND_TYPE.REFUND) {
            refundPayments = await RefundService.processRefund(this.state.invoice.id, payload)
        } else if (type === REFUND_TYPE.REFUND_ACCOUNT) {
            const response = await AppContext.getApiClient().post('/payment-transactions', payload)

            if (isError(response)) {
                return
            }

            refundPayments = this.mapOnAccountRefundResponseToRefundPaymentsResponse(response)
        }

        $("#" + REFUND_MODAL_ID).modal("hide")
        this.sendProposal('', '', '', '', '', '', '', '', '', true)
        this.setState({
            modal: <RefundConfirmationModal
                refundType={type}
                refundResponse={refundPayments}
                return={this.state.invoice}
                onClose={this.handleCloseModal}
            />
        })
    }

    mapOnAccountRefundResponseToRefundPaymentsResponse(response) {
        let currencyFormatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.state.invoice.attributes.currency,
        });

        const positiveTotal = this.state.invoice.attributes.totalAmount[0] === "-" ?
            this.state.invoice.attributes.totalAmount.substring(1) : this.state.invoice.attributes.totalAmount

        const dto = {
            id: "non-applicable",
            type: "refund-payments",
            attributes: {
                total: currencyFormatter.format(positiveTotal),
                refundPayments: [],
                currency: this.state.invoice.attributes.currency,
            }
        }


        response.data.forEach(invoice => {
            invoice.attributes.paymentTransactions.forEach(transaction => {

                const positiveAmount = transaction.attributes.payment.attributes.amount[0] === "-" ?
                    transaction.attributes.payment.attributes.amount.substring(1) : transaction.attributes.payment.attributes.amount

                dto.attributes.refundPayments.push({
                    id: transaction.attributes.payment.id,
                    type: "refund-payment",
                    attributes: {
                        identifier: transaction.attributes.payment.attributes.identifier,
                        amount: currencyFormatter.format(positiveAmount),
                        refundMethod: transaction.attributes.payment.attributes.type,
                        refundedPaymentId: "",
                        status: transaction.attributes.payment.attributes.status,
                    }
                })
            })
        })

        return new RefundPayments(dto)
    }

    markAsSent(e) {
        e.preventDefault()
        const totalAmountIsPositive = parseFloat(this.state.totalAmount) >= 0
        if (totalAmountIsPositive)
            this.setState({ loading: true })

        if (this.isReturn() && !totalAmountIsPositive) {
            this.setState({
                modal:
                    <PaymentRefundModal
                        id={REFUND_MODAL_ID}
                        onClose={this.handleCloseModal}
                        onRefund={this.handleRefund}
                        invoice={this.state.invoice}
                    />,
                refundModalVisible: true,
            })
        } else {
            this.sendProposal('', '', '', '', '', '', '', '', '', false)
        }
    }

    configureRecurringEmail(event) {
        event.preventDefault()
        const recurringInfo = this.state.recurringInfo && this.state.recurringInfo.attributes ? this.state.recurringInfo.attributes : {}
        const email = recurringInfo.emailAddresses ? recurringInfo.emailAddresses.split(',').map(a => a.toString().trim()) : this.getCustomerEmailAddresses()
        const ccEmail = recurringInfo.emailCCAddresses ? recurringInfo.emailCCAddresses.split(',').map(a => a.toString().trim()) : []
        const fromName = recurringInfo.emailFromName ? recurringInfo.emailFromName : this.state.proposal.attributes.variables.seller.name
        this.setState({
            modal: <SendEmailModal
                lastEmailSubject={recurringInfo.emailSubject}
                lastEmailContent={recurringInfo.emailContent}
                locationId={this.state.locationId}
                lastEmailButtonLabel={recurringInfo.emailButtonLabel}
                onSubmit={this.saveRecurringEmail}
                onClose={this.handleCloseModal}
                onCloseWithoutSubmit={(emailSubject, toEmail, ccEmail, emailContent, buttonLabel, fromName) => {
                    this.setState({
                        emailSubject,
                        toEmail,
                        ccEmail,
                        emailContent,
                        buttonLabel,
                        fromName,
                    })
                }}
                toEmail={this.state.toEmail || email}
                ccEmail={this.state.ccEmail || ccEmail}
                isCustomFromName={recurringInfo.emailFromName != ""}
                fromName={this.state.emailFromName ? this.state.emailFromName : fromName}
                subject={this.state.emailSubject}
                content={this.state.emailContent}
                buttonLabel={this.state.buttonLabel}
                proposalType={'invoice'}
                templateKey={'send-invoice'}
                isRecurringEmail={true}
                ctaLabel={<FormattedMessage
                    id="common.send_email.modal.save_btn"
                    defaultMessage="Save"
                />}
            />,
        })
    }


    getCustomerEmailAddresses() {
        return GlobalHelper.formatContactEmail(this.state.contact.attributes.email, this.state.contact.attributes.name)
    }

    createProposalAndOpenSms(event) {
        this.createProposal().then(res => {
            const publicLink = res.attributes.publicLink
            this.openSendSms(event, publicLink)
        })
    }

    openSendSms(event) {
        event.preventDefault()
        const project = this.state.projectObject
        const accountId = project.attributes.accountId
        const customerPhoneNumbers = project.attributes.contact.attributes.phoneNumbers
        const countryCode = this.state.invoice.attributes.location.attributes.organization.attributes.address.countryCode

        this.setState({
            modal: <SendSmsModal
                phoneNumber={GlobalHelper.getCustomerNumber(customerPhoneNumbers)}
                projectId={project.id}
                contactId={this.state.contactId}
                accountId={accountId}
                templateType={TYPE_SMS_INVOICE}
                countryCode={countryCode}
                onSubmit={() => this.sendProposal("", "", "", "", "", "", "", "", "", false)}
                onClose={this.handleCloseModal}
            />,
        })
    }

    openSendEmail(event) {
        event.preventDefault()
        this.setState({
            modal: <SendEmailModal
                onSubmit={this.sendProposal}
                locationId={this.state.locationId}
                onClose={this.handleCloseModal}
                toEmail={this.getCustomerEmailAddresses()}
                proposalType={'invoice'}
                templateKey={'send-invoice'}
            />,
        })
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            previewLoading: true,
        })
        this.createProposal().then(res => {
            this.setState({
                previewLoading: false,
                modal: <ProposalPreviewModal
                    onClose={this.handleCloseModal}
                    pdfLink={res.attributes.variables.document.pdfUri}
                    hash={res.attributes.hash}
                    publicLink={res.attributes.publicLink}
                    proposalType={'invoice'}
                />,
            })
        })
    }

    printPdf(e) {
        this.createProposal().then(res => {
            this.handleCloseModal()
            const printUrl = res.attributes.printUrl
            GlobalHelper.redirectToPrintPdf(printUrl)
        })
    }

    activateButton() {
        const createdInvoiceCount = this.state.recurringInfo.attributes.createdInvoiceCount
        if (this.state.status !== 'active' || (this.nextDueDateIsToday() && createdInvoiceCount === 0)) {
            const capturePayment = this.state.recurringInfo.attributes.capturePayment;
            const defaultCardsOnFile = this.state.invoice.attributes.contact.attributes.cardsOnFile
                .filter(card => card.attributes.isDefault);
            const defaultCard = defaultCardsOnFile.length > 0 ? defaultCardsOnFile[0] : undefined;

            if (this.nextDueDateIsToday() && capturePayment && defaultCard && createdInvoiceCount === 0) {
                return <ActionButton key={'activate-and-charge'} className="btn btn-success mb-2"
                    onClick={this.markAsActive}>
                    <Icon value={"check"} className={"mr-1"} />
                    <FormattedMessage
                        id="quote.edit.preview.activate_and_charge_btn"
                        defaultMessage="Activate and charge first invoice"
                    />
                </ActionButton>
            } else if (this.nextDueDateIsToday() && createdInvoiceCount === 0) {
                return <ActionButton key={'activate-and-create'} className="btn btn-success mb-2"
                    onClick={this.markAsActive}>
                    <Icon value={"check"} className={"mr-1"} />
                    <FormattedMessage
                        id="quote.edit.preview.activate_and_create_btn"
                        defaultMessage="Activate and create first invoice"
                    />
                </ActionButton>
            }

            return <ActionButton key={'activate'} className="btn btn-success mb-2" onClick={this.markAsActive}>
                <Icon value={"check"} className={"mr-1"} />
                <FormattedMessage
                    id="quote.edit.preview.activate_btn"
                    defaultMessage="Activate"
                />
            </ActionButton>
        }

        return ""
    }

    isRecurringInvoice() {
        return this.state.billingType === 'recurring'
    }

    isReturn() {
        return this.state.billingType === 'return'
    }

    canSendRecurringEmail() {
        return this.state.recurringInfo && this.state.recurringInfo.attributes.sendEmail
    }

    detailsText() {
        if (this.isRecurringInvoice()) {
            return <FormattedMessage
                id="invoice.edit.recurring_invoice_details.title"
                defaultMessage="Recurring details"
            />
        } else if (this.isReturn()) {
            return <FormattedMessage
                id="return.edit.return_details.title"
                defaultMessage="Return details"
            />
        }
        return <FormattedMessage
            id="invoice.edit.invoice_details.title"
            defaultMessage="Invoice details"
        />
    }

    saveButtonsAreDisabled() {
        if (!this.isReturn()) {
            return parseFloat(this.state.totalAmount) < 0
        }
        return parseFloat(this.state.totalAmount) > 0
    }


    getCustomerOwingBalance() {
        return this.state.customerAccount ? parseFloat(this.state.customerAccount.attributes.owingBalance) : 0
    }

    isOverCreditLimit() {
        if (this.isReturn()) {
            return false
        }

        if (!this.state.contact) {
            return false
        } else if (parseFloat(this.state.contact.attributes.creditLimit) === 0) {
            return false
        }
        return (this.getCustomerOwingBalance() + parseFloat(this.state.invoice.attributes.baseCurrencyTotalAmount)) >
            parseFloat(this.state.contact.attributes.creditLimit)
    }

    isShopifyReturn() {
        if (GlobalHelper.hasShopifyIntegration()) {
            if (this.state.invoice && this.state.invoice.attributes.billingType == BILLING_TYPE.RETURN) {
                return true
            }
        }
        return false
    }

    receivePayment(event) {
        event.preventDefault()
        this.setState({
            modal: <ReceivePaymentModal
                onClose={this.handlePaymentOnDraft}
                invoice={this.state.invoice}
            />
        })
    }


    handlePaymentOnDraft(paymentType, appliedCreditMemoId) {
        if (paymentType != '') {
            this.setState({
                paymentFromDraft: true,
                modal: <SendAsModal
                    onClose={this.handleCloseModal}
                    sendBySMS={(event) => this.createProposalAndOpenSms(event)}
                    sendByEmail={this.openSendEmail}
                    printPdf={this.printPdf}
                />
            })
        }
        else {
            this.handleCloseModal()
        }
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner className="py-2" />
        }
        let allowTableEdit = !this.state.exportedToLightspeed || AppContext.getUserLoggedIn().attributes.superUser
        if (this.isShopifyReturn()) {
            allowTableEdit = false
        }

        if (["active", "inactive", "finished"].includes(this.state.status) && this.state.billingType === 'recurring' && !this.state.editMode) {
            return <InvoiceRecurring
                invoice={this.state.invoice}
                quoteReference={this.state.quoteReference}
                project={this.state.projectObject}
                proposal={this.state.proposal}
                onRefresh={this.handleInvoiceRefresh}
                onEdit={this.handleEditInvoice}
                emails={this.state.emails}
                firstRecurringInvoice={this.state.firstRecurringInvoice}
            />
        }
        if (["sent", "partially-paid", "fully-paid", "voided"].includes(this.state.status) && !this.state.editMode) {
            return <InvoiceAnalytics
                invoice={this.state.invoice}
                quoteReference={this.state.quoteReference}
                orderReference={this.state.orderReference}
                priceListReference={this.state.priceListReference}
                recurringInvoice={this.state.recurringInvoice}
                relatedInvoice={this.state.relatedInvoice}
                project={this.state.projectObject}
                proposal={this.state.proposal}
                onRefresh={this.handleInvoiceRefresh}
                onEdit={this.handleEditInvoice}
                emails={this.state.emails}
                returns={this.state.returns}
                showReceivePaymentModal={this.state.showReceivePaymentModal}
                internalNotes={this.state.internalNotes}
            />
        }

        const isRecurring = this.isRecurringInvoice()

        const firstCol = []
        const secondCol = []
        if (this.state.quoteReference) {
            firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
                <label className="col-12 col-form-label custom-form-label" htmlFor="startedAt">
                    <FormattedMessage
                        id="invoice.edit.invoice_details.invoiced_quote_label"
                        defaultMessage="Invoiced quote"
                    />
                </label>
                <div className="col-12">
                    <p className="p-0 m-0">
                        <Link to={'/quotes/' + this.state.quoteReference.id + '/edit'}>
                            {this.state.quoteReference.attributes.identifier}
                        </Link>
                    </p>
                </div>
            </div>)
        }
        if (this.state.orderReference) {
            firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
                <label className="col-12 col-form-label custom-form-label" htmlFor="startedAt">
                    <FormattedMessage
                        id="invoice.edit.invoice_details.invoiced_order_label"
                        defaultMessage="Invoiced order"
                    />
                </label>
                <div className="col-12">
                    <p className="p-0 m-0">
                        <Link to={'/orders/' + this.state.orderReference.id + '/edit'}>
                            {this.state.orderReference.attributes.identifier}
                        </Link>
                    </p>
                </div>
            </div>)
        }
        if (this.state.externalOrders.length) {
            for (let i in this.state.externalOrders) {
                const order = this.state.externalOrders[i]
                firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
                    <label className="col-12 col-form-label custom-form-label" htmlFor="startedAt">
                        <FormattedMessage
                            id="invoice.edit.invoice_details.order_label"
                            defaultMessage="Order invoiced"
                        />
                    </label>
                    <div className="col-12">
                        <p className="p-0 m-0">
                            <a href={Integrations.getExternalOrderUrl(order)}>
                                #{order.attributes.externalId}
                            </a>
                        </p>
                    </div>
                </div>)
            }

        }
        if (this.state.dueDate && this.state.billingType === 'one-time') {
            firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
                <label className="col-12 col-form-label custom-form-label">
                    <FormattedMessage
                        id="invoice.edit.invoice_details.due_date_label"
                        defaultMessage="Due date"
                    />
                </label>
                <div className="col-12">
                    <InvoiceDueDate
                        value={this.state.dueDate}
                        invoiceId={this.state.invoiceId}
                        editable={true}
                    />
                </div>
            </div>)
        }

        if (['one-time', 'recurring'].includes(this.state.billingType)) {
            firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
                <label className="col-12 col-form-label custom-form-label">
                    <FormattedMessage
                        id="invoice.edit.invoice_details.payment_term_label"
                        defaultMessage="Payment term"
                    />
                </label>
                <div className="col-12">
                    <InvoicePaymentTerm
                        value={this.state.paymentTerm}
                        paymentTermId={this.state.paymentTermId}
                        invoiceId={this.state.invoiceId}
                        onChange={(paymentTerm, dueDate) => {
                            this.setState({
                                paymentTerm: paymentTerm,
                                dueDate: dueDate,
                            })
                        }}
                        editable={true}
                    />
                </div>
            </div>)
        }

        firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
            <label className="col-12 col-form-label custom-form-label">
                <FormattedMessage
                    id="invoice.edit.invoice_details.po_number_label"
                    defaultMessage="PO number"
                />
            </label>
            <div className="col-12">
                <InlineEditText
                    editable={true}
                    endPoint={'/invoices/' + this.state.invoiceId}
                    field={'poNumber'}
                    value={this.state.poNumber}
                />
            </div>
        </div>)

        if (isRecurring) {
            firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
                <label className="col-12 col-form-label custom-form-label">
                    <FormattedMessage
                        id="invoice.edit.invoice_details.interval_label"
                        defaultMessage="Interval"
                    />
                </label>
                <div className="col-12">
                    <RecurringInvoiceInterval
                        editable={true}
                        value={this.state.recurringInfo}
                        invoiceId={this.state.invoiceId}
                        onChange={info => {
                            this.setState({ recurringInfo: info })
                        }}
                    />
                </div>
            </div>)
            firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
                <label className="col-12 col-form-label custom-form-label">
                    <FormattedMessage
                        id="invoice.edit.invoice_details.schedule_label"
                        defaultMessage="Schedule"
                    />
                </label>
                <div className="col-12">
                    <RecurringInvoiceSchedule
                        editable={true}
                        value={this.state.recurringInfo}
                        invoiceId={this.state.invoiceId}
                        onChange={info => {
                            this.setState({ recurringInfo: info })
                        }}
                    />
                </div>
            </div>)
            if (this.state.recurringInfo.attributes.nextDueDate) {
                firstCol.push(<div key={firstCol.length} className="form-group row mb-0">
                    <label className="col-12 col-form-label custom-form-label">
                        <FormattedMessage
                            id="invoice.edit.invoice_details.next_due_date_label"
                            defaultMessage="Next invoice"
                        />
                    </label>
                    <div className="col-12">
                        <FormattedDate
                            year='numeric'
                            month='long'
                            day='numeric'
                            value={new Date(this.state.recurringInfo.attributes.nextDueDate)} />
                    </div>
                </div>)
            }
            secondCol.push(<div key={secondCol.length} className="row">
                <label className="col-12 col-form-label custom-form-label" htmlFor="seller">
                    <FormattedMessage
                        id="invoice.edit.invoice_details.options_label"
                        defaultMessage="Options"
                    />
                </label>
                <div className="col-12">
                    <RecurringInvoiceOptions
                        editable={true}
                        value={this.state.recurringInfo}
                        invoiceId={this.state.invoiceId}
                        contact={this.state.contact}
                        contactId={this.state.contactId}
                        onChange={info => {
                            this.setState({ recurringInfo: info })
                        }}
                        refreshInvoice={this.refreshInvoice}
                        locationId={this.state.locationId}
                    />
                </div>
            </div>)
        }

        secondCol.push(<div key={secondCol.length} className="row">
            <div className="form-group row px-3 mb-0">
                <label className="col-12 col-form-label custom-form-label" htmlFor="seller">
                    <FormattedMessage
                        id="invoice.edit.invoice_details.assigned_to_label"
                        defaultMessage="Assigned to"
                    />
                </label>
                <div className="col-12">
                    <InlineEditUser
                        editable={true}
                        endPoint={'/invoices/' + this.state.invoiceId}
                        field={'sellerId'}
                        value={this.state.sellerName}
                        userId={this.state.sellerId} />
                </div>
            </div>
        </div>)

        if (!isRecurring && !this.isReturn()) {
            secondCol.push(<div key={secondCol.length} className="row">
                <label className="col-12 col-form-label custom-form-label" htmlFor="seller">
                    <FormattedMessage
                        id="invoice.edit.invoice_details.sent_date_label"
                        defaultMessage="Sent date"
                    />
                </label>
                <div className="col-12">
                    <InlineEditDate
                        value={this.state.sentAt}
                        endPoint={'/invoices/' + this.state.invoiceId}
                        field={'sentAt'}
                        editable={true}
                    />
                </div>
            </div>)
        }
        secondCol.push(<div key={secondCol.length} className="row">
            <div className="form-group row px-3 mb-0">
                <label className="col-12 col-form-label custom-form-label" htmlFor="location">
                    <FormattedMessage
                        id="invoice.edit.invoice_details.location_label"
                        defaultMessage="Location"
                    />
                </label>
                <div className="col-12">
                    <InlineEditLocation
                        editable={GlobalHelper.hasAccessToAllLocations()}
                        endPoint={'/invoices/' + this.state.invoiceId}
                        value={this.state.locationName}
                        locationId={this.state.locationId}
                        onSave={(location) => {
                            this.setState({
                                locationId: location.locationId,
                                locationName: location.location
                            })
                        }}
                    />
                </div>
            </div>
        </div>)
        let pricingTableClassName = 'ui-module pt-0'
        if (this.state.exportedToLightspeed) {
            pricingTableClassName += ' border border-danger'
        }

        const actions = []

        if (["sent", "partially-paid", "fully-paid", "active", "inactive", 'finished'].includes(this.state.status)) {
            actions.push(<button key={actions.length} className="btn btn-outline-secondary mb-2 mr-2"
                onClick={this.closeEditMode}>
                <Icon value={"times"} className={"mr-1"} />
                <FormattedMessage
                    id="invoice.edit.close_edit_btn"
                    defaultMessage="Close edit mode"
                />
            </button>)
        }

        if (this.state.items.length > 0) {
            actions.push(<ActionButton key={actions.length} className="btn btn-outline-primary mb-2 mr-2"
                onClick={this.review}>
                <Icon value={"pencil-ruler"} className={"mr-1"} />
                <FormattedMessage
                    id="invoice.edit.edit_design_btn"
                    defaultMessage="Edit design"
                />
            </ActionButton >)

            if (this.isRecurringInvoice() && this.state.status !== 'inactive') {
                actions.push(<ActionButton key={actions.length} className="btn btn-outline-primary mr-2 mb-2"
                    onClick={this.markAsInactive}>
                    <Icon value={"toggle-off"} className={"mr-1"} />
                    <FormattedMessage
                        id="quote.edit.preview.mark_as_inactive_btn"
                        defaultMessage="Mark as inactive"
                    />
                </ActionButton>)
            }

            if (this.isRecurringInvoice() && this.canSendRecurringEmail()) {
                actions.push(<button key={actions.length} className="btn btn-primary mb-2 mr-2"
                    onClick={this.configureRecurringEmail}>
                    <Icon value={"envelope"} className={"mr-1"} />
                    <FormattedMessage
                        id="quote.edit.preview.configure_recurring_email_btn"
                        defaultMessage="Configure email"
                    />
                </button>)
            }

            if (this.isRecurringInvoice()) {
                actions.push(this.activateButton())
            }
            const allowedModalMessage = InvoiceHelper.GetOverCreditLimitMessagePermissionProceed(
                this.state.invoice.attributes.currency, this.getCustomerOwingBalance(), this.state.invoice.attributes.baseCurrencyTotalAmount,
                this.state.contact.attributes.creditLimit, true)

            const deniedModalMessage = InvoiceHelper.GetOverCreditLimitMessagePermissionProceed(
                this.state.invoice.attributes.currency, this.getCustomerOwingBalance(), this.state.invoice.attributes.baseCurrencyTotalAmount,
                this.state.contact.attributes.creditLimit, false)

            if (!this.isRecurringInvoice() && this.state.status === 'draft') {
                actions.push(<CreditLimitProtectionButton
                    owingBalance={this.getCustomerOwingBalance()}
                    invoiceBalance={parseFloat(this.state.invoice.attributes.baseCurrencyTotalAmount)}
                    creditLimit={parseFloat(this.state.contact.attributes.creditLimit)}
                    buttonClassName={"btn btn-outline-success mb-2 mr-2"}
                    onClickEventCallback={this.markAsSent}
                    buttonIcon={<Icon value={"bullseye"} className={"mr-1"} />}
                    buttonLabel={<FormattedMessage
                        id="invoice.edit.mark_as_done_btn"
                        defaultMessage="Mark as done"
                    />}
                    isDisabled={this.saveButtonsAreDisabled()}
                    allowedModalMessage={allowedModalMessage}
                    deniedModalMessage={deniedModalMessage}
                    isReturn={this.isReturn()}>
                </ CreditLimitProtectionButton>)
                if (this.state.priceListReference == null && !this.isReturn() && !GlobalHelper.hasIntegration(INTEGRATION_KEY.SQUARE)) {
                    actions.push(
                        <CreditLimitProtectionButton
                            owingBalance={this.getCustomerOwingBalance()}
                            invoiceBalance={parseFloat(this.state.invoice.attributes.baseCurrencyTotalAmount)}
                            creditLimit={parseFloat(this.state.contact.attributes.creditLimit)}
                            buttonClassName={"btn btn-success mb-2 mr-2"}
                            onClickEventCallback={this.receivePayment}
                            buttonIcon={<Icon value={"dollar-sign"} className={"mr-1"} />}
                            buttonLabel={<FormattedMessage
                                id="invoice.analytics.receive_payment_btn"
                                defaultMessage="Receive payment"
                            />}
                            isDisabled={this.saveButtonsAreDisabled()}
                            allowedModalMessage={allowedModalMessage}
                            deniedModalMessage={deniedModalMessage}>
                        </ CreditLimitProtectionButton>
                    )
                }
                if (!this.isReturn()) {
                    actions.push(<CreditLimitProtectionButton
                        owingBalance={this.getCustomerOwingBalance()}
                        invoiceBalance={parseFloat(this.state.invoice.attributes.baseCurrencyTotalAmount)}
                        creditLimit={parseFloat(this.state.contact.attributes.creditLimit)}
                        buttonClassName={"btn btn-success mb-2 mr-2"}
                        onClickEventCallback={(event) => this.createProposalAndOpenSms(event)}
                        buttonIcon={<Icon value={"mobile-alt"} className={"mr-1"} />}
                        buttonLabel={<FormattedMessage
                            id="invoice.edit.issue_and_send_sms_btn"
                            defaultMessage="SMS"
                        />}
                        isDisabled={this.saveButtonsAreDisabled()}
                        allowedModalMessage={allowedModalMessage}
                        deniedModalMessage={deniedModalMessage}
                        protectedFeatures={[AccountFeatures.FeatureSms]}>
                    </CreditLimitProtectionButton>
                    )
                    actions.push(<CreditLimitProtectionButton
                        owingBalance={this.getCustomerOwingBalance()}
                        invoiceBalance={parseFloat(this.state.invoice.attributes.baseCurrencyTotalAmount)}
                        creditLimit={parseFloat(this.state.contact.attributes.creditLimit)}
                        buttonClassName={"btn btn-success mb-2"}
                        onClickEventCallback={this.openSendEmail}
                        isDisabled={this.saveButtonsAreDisabled()}
                        buttonLabel={<FormattedMessage
                            id="checkout.email_placeholder"
                            defaultMessage="Email"
                        />}
                        buttonIcon={<Icon value={"envelope"} className={"mr-1"} />}
                        allowedModalMessage={allowedModalMessage}
                        deniedModalMessage={deniedModalMessage}>
                    </CreditLimitProtectionButton>)
                }
            }
        }
        return <div>
            <div className="row mb-5">
                <div className="col-12">
                    {this.state.redirect}
                    {this.state.modal}

                    {/* design for recurring invoice not done so still need the old components */}
                    {!this.isRecurringInvoice() ?
                        <div className="col-md-12">
                            <div className="px-3">
                                {this.state.projectObject &&
                                    <ProjectDetailsEditForm
                                        invoice={this.state.invoice}
                                        proposal={this.state.proposal}
                                        project={this.state.projectObject}
                                        onChange={(project) => this.updateContact(project.contactId)}
                                        isEditable={true}
                                        refreshObject={this.refreshInvoice}
                                    />
                                }
                            </div>
                        </div> : [<div className="col-md-12">
                            <div className="row px-3">
                                <h4 className="p-0 custom-lead">
                                    <FormattedMessage
                                        id="invoice.edit.contact_box.title"
                                        defaultMessage="Customer"
                                    />
                                </h4>
                            </div>
                            <ProjectCustomerEditForm
                                className="px-3"
                                value={this.state.contactId}
                                isCustomerEditable={true}
                                onChange={this.updateContact}
                                showLoyaltyBalance={AppContext.hasFeatureIntegration(Features.LoyaltyRedemption)}
                                renderContactEnabled={this.isRecurringInvoice()}
                            />
                        </div>,
                        <div className="row px-3">
                            <div className="col-12">
                                <h4 className={'custom-lead'}>
                                    {this.detailsText()}
                                </h4>
                            </div>
                        </div>,
                        <div className="row m-0 px-3">
                            <div className="col-12 ui-module">
                                <div className="row justify-content-end">
                                    {
                                        <div className="col-sm-12 col-md-6">
                                            <div className="row">
                                                <div className="col-12">
                                                    {firstCol}
                                                    {this.renderCustomField(0)}
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="col-sm-12 col-md-6">
                                        {secondCol}
                                        {this.renderCustomField(1)}
                                    </div>
                                </div>
                            </div>
                        </div>]
                    }

                    <div className="row px-3">
                        <div className="col-12 d-flex justify-content-between">
                            <h4 className={'custom-lead'}>
                                <FormattedMessage
                                    id="invoice.edit.items.items_title"
                                    defaultMessage="Items"
                                />
                            </h4>
                            <BottomPriceToggle />
                            {this.state.exportedToLightspeed ? <h5 className="p-0">
                                ({!this.isReturn() ? <small className={'text-danger'}>
                                    <Icon value={'exclamation-triangle'} className={'mr-2'} />
                                    <FormattedMessage
                                        id="invoice.edit.box.items_warning_lightspeed"
                                        defaultMessage="This invoice has already been exported to Lightspeed. Modification on the pricing table is not allowed."
                                    />
                                </small> : <small className={'text-danger'}>
                                    <Icon value={'exclamation-triangle'} className={'mr-2'} />
                                    <FormattedMessage
                                        id="invoice.edit.box.return_items_warning_lightspeed"
                                        defaultMessage="This return has already been exported to Lightspeed. Modification on the pricing table won't be exported to Lightspeed."
                                    />
                                </small>})
                            </h5> : ''}
                        </div>
                    </div>
                    <div className="m-0 px-3">
                        <div className={pricingTableClassName}>
                            {this.renderItems(this.state.items, allowTableEdit)}
                            {allowTableEdit ?
                                <div className="col-12 quote-add-product" onClick={this.handleAddProductLink}>
                                    <a href="#" className="btn btn-link btn-add-product">
                                        <FormattedMessage
                                            id="invoice.edit.add_product_btn"
                                            defaultMessage="Add a product"
                                        />
                                    </a>
                                </div> : ''}
                            <div className={"row mb-3"}>
                                <div className={"col-md-4"}>
                                    {!this.state.exportedToLightspeed || AppContext.getUserLoggedIn().attributes.superUser ?
                                        <div className={"mt-4 pt-2 mb-0 w-100"}>
                                            <button className={"btn btn-outline-primary"} onClick={this.addGroup}>
                                                <Icon value={"layer-group"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="invoice.edit.add_group_btn"
                                                    defaultMessage="Add a group"
                                                />
                                            </button>
                                        </div> : ''}
                                    {GlobalHelper.getEnabledCurrenciesSelectOptions().length > 1 ?
                                        <div className={"pt-3 w-100"}>
                                            <QuoteCurrency
                                                className={'mr-2 w-100'}
                                                invoiceId={this.state.invoiceId}
                                                editable={!this.state.exportedToLightspeed || AppContext.getUserLoggedIn().attributes.superUser}
                                                currency={this.state.currency}
                                                onChange={this.refreshInvoice}
                                            />
                                        </div> : ''}
                                    {!isRecurring ? <div className={"pt-3 w-100"}>
                                        <QuoteIdentifier
                                            className={'mr-2 w-100'}
                                            identifierId={this.state.identifierId}
                                            identifier={this.state.identifier}
                                            editable={!this.state.exportedToLightspeed || AppContext.getUserLoggedIn().attributes.superUser}
                                            onChange={this.refreshInvoice}
                                        />
                                    </div> : ''}
                                </div>
                                <div className={"col-md-8 pb-3"}>
                                    <PricingTableTotals
                                        mainObject={INVOICES}
                                        totalClassName={'col-lg-8 col-md-12'}
                                        allowEdit={allowTableEdit}
                                        rows={this.state.items}
                                        mainObjectId={this.state.invoiceId}
                                        invoiceId={this.state.invoiceId}
                                        contactId={this.state.contactId}
                                        showLoyalty={AppContext.hasFeatureIntegration(Features.LoyaltyRedemption)}
                                        onChange={this.refreshInvoice}
                                        depositType={this.state.depositType}
                                        depositAmount={this.state.depositAmount}
                                        depositRatio={this.state.depositRatio}
                                        hideDeposit={isRecurring || this.isReturn()}
                                        hideMargin={this.isReturn()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                    <div className="col-12 ui-module sticky-bottom-module">
                        <div className="row justify-content-end">
                            {this.saveButtonsAreDisabled() &&
                                <div>
                                    <p className="text-align-right text-danger mb-3 mr-3">
                                        <Icon value={"exclamation"} className={"mr-1"} />
                                        {!this.isReturn() &&
                                            <Link to={{
                                                pathname: "/contacts/" + this.state.contactId + "/details",
                                                state: {
                                                    activeTab: 'returns'
                                                }
                                            }} className="text-danger">
                                                <FormattedMessage
                                                    id="invoice.negative_total_amount_warning"
                                                    defaultMessage="The total amount of this invoice is negative. Please create a return instead."
                                                />
                                            </Link>}
                                        {this.isReturn() &&
                                            <Link to={{
                                                pathname: "/contacts/" + this.state.contactId + "/details",
                                                state: {
                                                    activeTab: 'invoices'
                                                }
                                            }} className="text-danger">
                                                <FormattedMessage
                                                    id="return.positive_total_amount_warning"
                                                    defaultMessage="The total amount of this return is positive. Please create an invoice instead."
                                                />
                                            </Link>}
                                    </p>
                                </div>
                            }
                        </div>
                        <div className="row justify-content-end">
                            {!this.state.deletedAt ?
                                <div className="col-12 d-flex justify-content-between align-content-center flex-wrap">
                                    <div className={"d-flex"}>
                                        <div className={""}>
                                            <ConfirmButton
                                                onModalRender={(m, c) => {
                                                    this.setState({ modal: m, }, c)
                                                }}
                                                onClick={this.deleteInvoice}
                                                identifier={this.state.identifier}
                                                className="btn btn-outline-danger mr-2 mb-2"
                                            >
                                                <Icon value={"trash"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="invoice.edit.delete_btn"
                                                    defaultMessage="Delete"
                                                />
                                            </ConfirmButton>
                                            {this.state.items.length > 0 ?
                                                <ActionButton className={"btn btn-outline-primary mb-2"}
                                                    isLoading={this.state.previewLoading}
                                                    onClick={this.openPreview}>
                                                    <Icon value={"eye"} className={"mr-1"} />
                                                    <FormattedMessage
                                                        id="invoice.edit.preview_btn"
                                                        defaultMessage="Preview"
                                                    />
                                                </ActionButton> : ''}
                                        </div>
                                    </div>
                                    <div className={""}>
                                        {actions}
                                    </div>
                                </div> : [<div className="col-3" key={"1"}>
                                    <ActionButton className={"btn btn-sm btn-warning mr-2 mb-2"}
                                        onClick={this.unarchiveInvoice}>
                                        <FormattedMessage
                                            id="invoice.edit.unarchive_btn"
                                            defaultMessage="Unarchive"
                                        />
                                    </ActionButton>
                                </div>,
                                <div className="col-9" key={"2"}>
                                    <p className="text-align-right text-warning m-0">
                                        <FormattedMessage
                                            id="invoice.archived_info"
                                            defaultMessage="This invoice is archived and can't be found in search results."
                                        />
                                    </p>
                                </div>]}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    }

}

const mapState = (state, props) => {
    return { ...props }
}
const mapDispatch = (dispatch) => {
    return {
        dispatch,
    }
}
export default connect(mapState, mapDispatch)(injectIntl(InvoiceEdit))





// WEBPACK FOOTER //
// ./src/invoice/invoice.component.jsx